import React from 'react'
import {Helmet} from 'react-helmet-async'
import {Button} from '../../../components/library/buttons/index'
import {Icon} from '../../../components/library/icon/icon'
import {
  PermissionAction,
  PermissionResource
} from '../../../data/workbench-api/generated/types'
import {EnvironmentNode} from '../../../environment'
import {WebhookList} from '../../webhooks'
import {IconHeading, Section, SectionContent, SectionInfo} from '../components'

export const Webhooks = ({environment}: {environment: EnvironmentNode}) => {
  const canEdit = environment.hasPermission(
    PermissionResource.WebhooksEndpoint,
    PermissionAction.Edit
  )

  return (
    <WebhookList
      environment={environment}
      bleed="#f2f2f2"
      renderLayout={(content, addNew) => (
        <Section>
          <Helmet>
            <title>Webhook subscriptions</title>
          </Helmet>
          <header>
            <IconHeading>
              <Icon name="webhook" /> Webhook subscriptions
            </IconHeading>

            <nav>
              <Button disabled={!canEdit} onClick={addNew}>
                New subscription
              </Button>
            </nav>
          </header>

          <SectionInfo>
            <p>Manage webhook subscriptions for your application</p>
          </SectionInfo>

          <SectionContent>{content}</SectionContent>
        </Section>
      )}
    />
  )
}
